import React from 'react'
import "./subSolutionsMob.scss";
import { FaIndustry } from "react-icons/fa";
import { SubMenuLink } from '../subSolutions';
import { useTranslation } from 'react-i18next';

export default function SubMenuSolutionsMob() {
  const { t } = useTranslation()

  return (
    <div className="container-submenuSolutionsMob">
      <div className="submenu-SolutionsMob">
        <div className="porindustriaMob">
          <div className="title-porIndustriaMob">
            <h1><FaIndustry /> Por Setor</h1> {/*antiga por industria*/}
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ paddingRight: "2em" }}>
              <SubMenuLink link={"/retail"} text={t("navbar.solutions.sectors.retail_text")} />
              <SubMenuLink link={"/financial"} text={t("navbar.solutions.sectors.financial_text")} />
              <SubMenuLink link={"/publicSector"} text={t("navbar.solutions.sectors.public_sector_text")} />
              <SubMenuLink link="/industry" text={t("navbar.solutions.sectors.industry_text")} />
            </div>
            <div>
              <SubMenuLink link="/education" text={t("navbar.solutions.sectors.education_text")} />
              <SubMenuLink link="/ecommerce" text={t("navbar.solutions.sectors.ecommerce_text")} />
              <SubMenuLink link="/health" text={t("navbar.solutions.sectors.health_text")} />
              <SubMenuLink link={"/telecom"} text={t("navbar.solutions.sectors.telecom_text")} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
